import ShopArticleTaxModelBase from '../_generated/modelBases/shop-article-tax-model-base';

export default class ShopArticleTaxModel extends ShopArticleTaxModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
